import React from "react";
import "./pages.css";

function About() {
  return (
    <div className="about_body">
      <h1>
        About Varstack<sup>2</sup>
      </h1>
      <section className="about_section">
        <p>
          Varstack<sup>2</sup> is a tool which allows users to query multiple
          cancer gene databases at the same time and presents information all in
          one place. It incorporates data from various databases, currently, ClinVar, UCSC
          Genome Browser, cBioPortal, ClinicalTrials.gov, and CIViC. Data is
          accessed using relevant APIs, meaning that the returned information is
          up to date and current with the existing versions of the databases.
          The use of all data within VarStack<sup>2</sup> is
          intended for research use only. It is not for diagnostic and clinical
          decision-making purposes.
        </p>
      </section>
      <h3>Database Information</h3>
      <ul>
        <li>
          <a href="https://www.ncbi.nlm.nih.gov/clinvar/">
            <b>ClinVar</b>
          </a>
        </li>
        <li>Links to the CinVar site search for the given parameters.</li>
        <li>
          <a href="https://www.cbioportal.org/">
            <b>cBioPortal </b>
          </a>
        </li>
        <li>
          Creates a graph which shows the number of appearances of the chosen
          peptide change in the chosen cancer. API v3.0.1
        </li>
        <li>
          <a href="https://genome.ucsc.edu/">
            <b>UCSC Genome Browser </b>
          </a>
        </li>
        <li>
          Links to the UCSC genome browser for the chosen peptide change and
          codon modification.
        </li>
        <li>
          <a href="https://clinicaltrials.gov/">
            <b>ClinicalTrials.gov </b>
          </a>
        </li>
        <li>
          Provides information regarding clinical trials using the given gene
          and peptide change (including Status, Study Title, Conditions,
          Interventions, and Locations.) REST API v2
        </li>
        <li>
          <a href="https://civicdb.org/">
            <b>CIViC </b>
          </a>
        </li>
        <li>
          Provides information regarding the given variant (including Variant
          Name, Variant ID, Coordinates, Allele Registry ID, Molecular Profile,
          Disease, Evidence Type, Evidence Level, Evidence Rating, Evidence
          Direction, Therapies, Therapy Interaction, Description, Source, and a
          CIViC Link) GraphQL API v2.5.24
        </li>
      </ul>

      <h3>System Information</h3>
      <p>
        Varstack<sup>2</sup> is built using the React.js framework.
        cBioPortal and Clinical Trials are accessed using the site's
        Application Programming Interface (API), and the UCSC genome browser and
        ClinVar are viewed using an iframe.
      </p>
    </div>
  );
}

export default About;
